<template>
  <div class="container o-form-page">
    <o-working-overlay :working="working"></o-working-overlay>

    <o-section :title="title" @click="enableDebug($event)" :level="0">
      <item-form
        :form-state="formState"
        :item="item"
        :server-errors="serverErrors"
        :notificationShown="notificationShown"
        :blockedStartDate="blockedStartDate"
        :blockedEndDate="blockedEndDate"
        @changedDates="evaluateDates($event)"
      ></item-form>
    </o-section>

    <o-action-buttons
      :item="item"
      :form-state="formState"
      :create="create"
      @save="doSave"
      @saveAndClose="doSaveAndClose"
      @saveAndNew="doSaveAndNew"
      @delete="doDeleteItem"
      :show-create-and-new="true"
    ></o-action-buttons>
  </div>
</template>

<script>
import {
  CreateFormPageMixin,
  CreateGroupPermissionMixin,
  UnsavedMixin,
} from "../../../vue-ocom/mixins";
import ItemForm from "../components/ItemForm.vue";
import OActionButtons from "../../../vue-ocom/components/forms/OActionButtons";
import OSection from "../../../vue-ocom/components/layout/OSection";
import OWorkingOverlay from "../../../vue-ocom/components/OWorkingOverlay";
import { mapMutations } from "vuex";
import moment from "moment";

export default {
  mixins: [
    UnsavedMixin,
    CreateFormPageMixin("LeaveRequestType", "leave_request_type"),
    CreateGroupPermissionMixin("LeaveRequestType"),
  ],
  components: {
    OSection,
    OWorkingOverlay,
    OActionButtons,
    ItemForm,
  },
  data: () => ({
    notificationShown: false,
    blockedStartDate: null,
    blockedEndDate: null,
  }),
  methods: {
    ...mapMutations(["showMessage"]),
    evaluateDates(dates) {
      var start_date = dates["start_date"];
      var end_date = dates["end_date"];

      var vm = this;
      var list_options = {
        limit: 10000,
        offset: 0,
        filter: "for_block_out_dates",
        params: {
          start_date: start_date,
          end_date: end_date,
        },
      };

      this.notificationShown = false;

      if (start_date !== null && end_date !== null) {
        this.$store
          .dispatch("BlockOutDateModule/getAll", list_options)
          .then((response) => {
            if (response.total_items > 0 && !vm.notificationShown) {
              vm.notificationShown = true;
              vm.blockedStartDate = moment(response["items"][0]["start_date"])
                .format("DD/MM/YYYY")
                .toString();
              vm.blockedEndDate = moment(response["items"][0]["end_date"])
                .format("DD/MM/YYYY")
                .toString();
            }
          })
          .catch((error) => {
            vm.showMessage({
              message: "An error occured",
              type: "danger",
              show: true,
            });
          });
      }
    },
  },
  computed: {
    title() {
      if (this.create) {
        return "Create Leave Request Type ";
      }

      return "Edit Leave Request Type ";
    },
  },
};
</script>
